import Factory from '../di/factory';


class ContextFactory extends Factory {

	constructor({container, prefix = '', suffix = 'Context'}) {
		super({container: container, prefix: prefix, suffix: suffix});
    }

}


export default ContextFactory;
